/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The LogControllerDtoAccountLoginLogListAccountLoginLogData model module.
 * @module model/LogControllerDtoAccountLoginLogListAccountLoginLogData
 * @version 1.0
 */
class LogControllerDtoAccountLoginLogListAccountLoginLogData {
    /**
     * Constructs a new <code>LogControllerDtoAccountLoginLogListAccountLoginLogData</code>.
     * @alias module:model/LogControllerDtoAccountLoginLogListAccountLoginLogData
     */
    constructor() { 
        
        LogControllerDtoAccountLoginLogListAccountLoginLogData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>LogControllerDtoAccountLoginLogListAccountLoginLogData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/LogControllerDtoAccountLoginLogListAccountLoginLogData} obj Optional instance to populate.
     * @return {module:model/LogControllerDtoAccountLoginLogListAccountLoginLogData} The populated <code>LogControllerDtoAccountLoginLogListAccountLoginLogData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new LogControllerDtoAccountLoginLogListAccountLoginLogData();

            if (data.hasOwnProperty('logNo')) {
                obj['logNo'] = ApiClient.convertToType(data['logNo'], 'Number');
            }
            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('userType')) {
                obj['userType'] = ApiClient.convertToType(data['userType'], 'Number');
            }
            if (data.hasOwnProperty('loginAt')) {
                obj['loginAt'] = ApiClient.convertToType(data['loginAt'], 'Date');
            }
            if (data.hasOwnProperty('userOs')) {
                obj['userOs'] = ApiClient.convertToType(data['userOs'], 'String');
            }
            if (data.hasOwnProperty('deviceId')) {
                obj['deviceId'] = ApiClient.convertToType(data['deviceId'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>LogControllerDtoAccountLoginLogListAccountLoginLogData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>LogControllerDtoAccountLoginLogListAccountLoginLogData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }
        // ensure the json data is a string
        if (data['userOs'] && !(typeof data['userOs'] === 'string' || data['userOs'] instanceof String)) {
            throw new Error("Expected the field `userOs` to be a primitive type in the JSON string but got " + data['userOs']);
        }
        // ensure the json data is a string
        if (data['deviceId'] && !(typeof data['deviceId'] === 'string' || data['deviceId'] instanceof String)) {
            throw new Error("Expected the field `deviceId` to be a primitive type in the JSON string but got " + data['deviceId']);
        }

        return true;
    }


}



/**
 * @member {Number} logNo
 */
LogControllerDtoAccountLoginLogListAccountLoginLogData.prototype['logNo'] = undefined;

/**
 * @member {Number} accountNo
 */
LogControllerDtoAccountLoginLogListAccountLoginLogData.prototype['accountNo'] = undefined;

/**
 * @member {String} email
 */
LogControllerDtoAccountLoginLogListAccountLoginLogData.prototype['email'] = undefined;

/**
 * @member {Number} userType
 */
LogControllerDtoAccountLoginLogListAccountLoginLogData.prototype['userType'] = undefined;

/**
 * @member {Date} loginAt
 */
LogControllerDtoAccountLoginLogListAccountLoginLogData.prototype['loginAt'] = undefined;

/**
 * @member {String} userOs
 */
LogControllerDtoAccountLoginLogListAccountLoginLogData.prototype['userOs'] = undefined;

/**
 * @member {String} deviceId
 */
LogControllerDtoAccountLoginLogListAccountLoginLogData.prototype['deviceId'] = undefined;






export default LogControllerDtoAccountLoginLogListAccountLoginLogData;

